import { Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from '../../generic/service/filter.service';

@Component({
    selector: 'filter-price',
    styleUrls: ['./filter.component.scss'],
    template: ` <div class="filter-bar-part filter-price">
        <h4 i18n="Price@@product.feature.price">Price</h4>
        <form
            class="filter-range-form"
            [formGroup]="form"
            (ngSubmit)="onSubmit()">
            <input
                type="text"
                placeholder="From"
                i18n-placeholder="Filter from@@filter.from"
                autocomplete="off"
                [formControl]="form.controls['priceFrom']"
                pattern="[0-9]*[.,]?[0-9]+" />

            <input
                type="text"
                placeholder="To"
                i18n-placeholder="Filter to@@filter.to"
                autocomplete="off"
                [formControl]="form.controls['priceTo']"
                pattern="[0-9]*[.,]?[0-9]+" />

            <button
                class="button theme-btn-secondary"
                type="submit"
                i18n="filter submit button@@filter.submit.button">
                OK
            </button>
        </form>
    </div>`,
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule],
})
export class FilterPriceComponent implements OnDestroy {
    private filterService = inject(FilterService);
    private formBuilder = inject(UntypedFormBuilder);

    form: UntypedFormGroup;

    private filterStateChangedSubscription: Subscription;

    constructor() {
        const filterState = this.filterService.getFilterState();

        this.form = this.formBuilder.group({
            priceFrom: [filterState.priceFrom],
            priceTo: [filterState.priceTo],
        });

        this.filterStateChangedSubscription =
            this.filterService.filterStateChanged.subscribe(newState => {
                this.form.get('priceFrom')?.setValue(newState.priceFrom);
                this.form.get('priceTo')?.setValue(newState.priceTo);
            });
    }

    ngOnDestroy(): void {
        this.filterStateChangedSubscription.unsubscribe();
    }

    onSubmit() {
        const filterState = this.filterService.getFilterState();

        if (this.form.invalid) {
            return;
        }

        const formValues = this.form.value;

        // Check if one of the values has changed
        if (
            formValues.priceFrom !== filterState.priceFrom ||
            formValues.priceTo !== filterState.priceTo
        ) {
            this.filterService.setPrice(
                formValues.priceFrom,
                formValues.priceTo,
            );
        }
    }
}
